import { BrowserRouter, Route, Routes } from "react-router-dom";

import AppShell from "./components/AppShell";
import RequireAuth from "./components/RequireAuth";
import RequireRole from "./components/RequireRole";
import ScrollRestoration from "./components/ScrollRestoration";
import AreaChrome from "./components/dss/AreaChrome";
import DebugOverlay from "./components/dss/DebugOverlay";
import ViewAsBanner from "./components/dss/ViewAsBanner";
import AddEvent from "./pages/AddEvent";
import AddFine from "./pages/AddFine";
import AddMember from "./pages/AddMember";
import AddTransaction from "./pages/AddTransaction";
import AdminPage from "./pages/AdminPage";
import EditEvent from "./pages/EditEvent";
import EditFine from "./pages/EditFine";
import EditMember from "./pages/EditMember";
import EditTransaction from "./pages/EditTransaction";
import EditVotableEventPage from "./pages/EditVotableEventPage";
import EventDetails from "./pages/EventDetails";
import FinancePage from "./pages/FinancePage";
import GaltonBoardPage from "./pages/GaltonBoardPage";
import HomePage from "./pages/HomePage";
import ListPenaltiesPage from "./pages/ListPenaltiesPage";
import LoginPage from "./pages/LoginPage";
import Me from "./pages/Me";
import MembersRoles from "./pages/MembersRoles";
import RoulettePage from "./pages/RoulettePage";
import KartPage from "./pages/KartPage";
import Signup from "./pages/Signup";
import TransactionsPage from "./pages/TransactionsPage";
import VotableEventPage from "./pages/VotableEventPage";
import VotableEventResultPage from "./pages/VotableEventResultPage";

function App() {
  return (
    <BrowserRouter>
      <ScrollRestoration />
      <AreaChrome />
      <ViewAsBanner />
      <DebugOverlay />
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/me" element={<RequireAuth><Me /></RequireAuth>} />

        <Route
          path="/vote/:eventId"
          element={
            <RequireAuth>
              <VotableEventPage />
            </RequireAuth>
          }
        />
        <Route
          path="/vote/:eventId/result"
          element={
            <RequireAuth>
              <VotableEventResultPage />
            </RequireAuth>
          }
        />
        {/* Not RequireRole: an event's host may manage its vote without
            being an admin. EditVotableEventPage does its own admin-or-host
            check and bounces anyone else back to the samling. */}
        <Route
          path="/vote/:eventId/edit"
          element={
            <RequireAuth>
              <EditVotableEventPage />
            </RequireAuth>
          }
        />

        <Route
          path="/edit/:eventId"
          element={
            <RequireRole anyOf={["ADMIN"]}>
              <EditEvent />
            </RequireRole>
          }
        />
        {/* Read-only view for every member. React Router ranks the static
            "/event/add" above this dynamic segment, so they don't collide. */}
        <Route
          path="/event/:eventId"
          element={
            <RequireAuth>
              <EventDetails />
            </RequireAuth>
          }
        />
        <Route
          path="/event/add"
          element={
            <RequireRole anyOf={["ADMIN"]}>
              <AddEvent />
            </RequireRole>
          }
        />
        <Route
          path="/admin/members"
          element={
            <RequireRole anyOf={["ADMIN"]}>
              <MembersRoles />
            </RequireRole>
          }
        />
        <Route
          path="/admin/members/add"
          element={
            <RequireRole anyOf={["ADMIN"]}>
              <AddMember />
            </RequireRole>
          }
        />
        <Route
          path="/admin/members/:memberId"
          element={
            <RequireRole anyOf={["ADMIN"]}>
              <EditMember />
            </RequireRole>
          }
        />

        <Route
          path="/fines/add"
          element={
            <RequireRole anyOf={["ADMIN", "TAX_COLLECTOR"]}>
              <AddFine />
            </RequireRole>
          }
        />
        <Route
          path="/fines/:fineId"
          element={
            <RequireRole anyOf={["ADMIN", "TAX_COLLECTOR"]}>
              <EditFine />
            </RequireRole>
          }
        />

        {/* Booking a movement is admin-only — narrower than fines, which the
            Skatteminister also manages, because this is the loge's account
            rather than who owes what. Static before dynamic, so "add" isn't
            read as a transaction id. */}
        <Route
          path="/finance/add"
          element={
            <RequireRole anyOf={["ADMIN"]}>
              <AddTransaction />
            </RequireRole>
          }
        />
        <Route
          path="/finance/:transactionId"
          element={
            <RequireRole anyOf={["ADMIN"]}>
              <EditTransaction />
            </RequireRole>
          }
        />

        <Route element={<RequireAuth><AppShell /></RequireAuth>}>
          <Route path="/" element={<HomePage />} />
          <Route path="/penalties" element={<ListPenaltiesPage />} />
          {/* Every member reads the ledger; only admin writes to it. Kept
              inside the shell rather than pushed full-screen: it belongs to
              the tab, and a list you might read for a while shouldn't take
              the way out of it off the screen. */}
          <Route path="/finance" element={<FinancePage />} />
          <Route path="/finance/transactions" element={<TransactionsPage />} />
          <Route path="/lod" element={<GaltonBoardPage />} />
          <Route path="/lod/roulette" element={<RoulettePage />} />
          <Route path="/lod/kart" element={<KartPage />} />
          <Route
            path="/edit"
            element={
              <RequireRole anyOf={["ADMIN"]}>
                <AdminPage />
              </RequireRole>
            }
          />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
